import { Observable } from "rxjs";
import { Plan } from "@planard/@core/entities/plan";

export abstract class PlanData {
  abstract listPrices(
    scenarioId: number,
    approveRequestId?: number
  ): Observable<any>;

  abstract costTrend(data: any): Observable<any>;

  abstract costOverview(data: any): Observable<any>;

  abstract update(plan: Plan): Observable<any>;

  abstract listApproverUsersSubDepartments(): Observable<any>;
}
